module.exports = __webpack_public_path__ + "static/media/Stephen Kagaruki.8c5b1494.jpg";